import { Component, EventEmitter, Output, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ContactUsComponent } from '../../portal/modals/contact-us/contact-us.component';
import { MatDialog } from '@angular/material/dialog';
interface Link {
  path: string;
  title: string;
  target?: string; // Optional target property
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Output() onMenuOpen: EventEmitter<boolean> = new EventEmitter();

  isMenuClosed = true; // Default menu state
  navLinks: Link[] = [
    { path: 'home', title: 'Home' },
    { path: 'submissions', title: 'Enrollments' },
    { path: 'profile', title: 'Profile' },
  ];

  mobileOnlyLinks: Link[] = [
    { path: 'https://merckhelps.com/faq.aspx', title: 'FAQ', target: '_blank'},
    { path: 'https://www.merck.com/terms-of-use/', title: 'Terms of Use', target: '_blank' },
    { path: 'https://www.msdprivacy.com/us/en/', title: 'Privacy', target: '_blank'},
    { path: '#', title: 'Contact Us', target: '_self' },
  ];
  // openModal(event: Event): void {
  //   event.preventDefault(); // Prevents the default action of the link
  //   // Logic to open the modal
  //   console.log('Contact Us modal opened.');
  // }

  constructor(private breakpointObserver: BreakpointObserver, private dialog: MatDialog,) {}

  // @HostListener('window:resize', [])
  // onResize() {
  //   const width = window.innerWidth;
  //   this.isTablet = width > 576 && width <= 768; // Tablet breakpoint
  //   this.isMobile = width <= 576; // Mobile breakpoint
  // }


  toggleMenu() {
    this.isMenuClosed = !this.isMenuClosed;
    this.onMenuOpen.emit(this.isMenuClosed);
  }
  closeMenu() {
    this.isMenuClosed = true;
  }
  openModal(event: Event): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(ContactUsComponent, {
      minWidth: '50vw', minHeight: '70vh', autoFocus: false, disableClose: true,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('User selected:', result);
      } else {
        console.log('Modal closed without selection');
      }
    });
  }
}